import { Typography } from "@mui/material";
import React, { useState } from "react";
import config from "../../../../../config";
import { Button } from "../../../../../components/Button/Button";
import Qr from "../../../../../components/Qr/Qr";
import { IEmbed } from "../../embedsV2/interface";
import { IconGoToTab } from "../../../../../utils/icons";
import QRCodeStyling from "qr-code-styling";

interface Props {
  embed: IEmbed;
  openSettings: () => void;
}

export function QrCodePanel({ embed, openSettings }: Props) {
  const [isCopied, setIsCopied] = useState<boolean>();

  const formatUrl = (url: any = "") => url?.replace(/ /g, "-").toLowerCase();

  const formatSettings = (source: string, preview = false) => {
    let previewString = "";
    if (preview) previewString = "&preview=true";
    return `?source=${source}${previewString}`;
  };

  const formatLandingUrl = (source: string = "landing", preview = false) => {
    let previewString = "";
    if (preview) previewString = "&preview=true";
    return `${config.EMBED_HOST}/brands/${embed?.brand?.id}/${
      embed?.brand?.slug
    }-/landing/${embed?.id}/${formatUrl(embed?.name)}${formatSettings(
      source
    )}${previewString}`;
  };

  const onCopyUrlBtnClick = () => {
    navigator.clipboard.writeText(formatLandingUrl("landing"));
    setIsCopied(true);
    setTimeout(setIsCopied, 2000);
  };

  const makeBtn = (
    text: string,
    callback: any,
    icon?: JSX.Element,
    customClassName?: string
  ) => (
    <Button
      className={`!flex gap-2 !px-4 items-center justify-center ${customClassName}`}
      onClick={callback}
    >
      <Typography>{text}</Typography>
      {icon}
    </Button>
  );

  const downloadQr = () => {
    const qr = new QRCodeStyling({
      margin: 10,
      dotsOptions: {
        // Stays literal: qr-code-styling bakes this into the downloaded PNG,
        // which has to be scannable black-on-white regardless of the app theme.
        color: "#000",
        type: "square",
      },
      data: formatLandingUrl("qr"),
      width: 1000,
      height: 1000,
    });
    qr.download({ extension: "png" });
  };

  return (
    <div className="flex flex-col gap-2 justify-between h-full">
      <div className="p-6 flex flex-col w-full gap-4 h-full">
        <div className="p-4 bg-surface-2 rounded-md h-full flex justify-center items-center">
          <Qr qrSize={180} url={formatLandingUrl("qr")} disableDownload />
        </div>
      </div>
      <div className="pt-4 flex items-center justify-end px-6 gap-2 border-t border-border-token">
        {makeBtn("Download QR Code", downloadQr)}
        {makeBtn(
          "Preview QR Link",
          () => window.open(formatLandingUrl("landing", true), "_blank"),
          <IconGoToTab stroke="currentColor" />,
          "!text-text-1 !bg-surface-2"
        )}
        {/* {makeBtn(
          isCopied ? "Copied!" : "Copy Video URL",
          onCopyUrlBtnClick,
          <IconAttachment stroke="#fff" />
        )}
        {makeBtn(
          "Preview Video",
          () => window.open(formatLandingUrl("landing", true), "_blank"),
          <IconGoToTab stroke="#444" />,
          "!text-black !bg-lightgray3"
        )} */}
      </div>
    </div>
  );
}
